import Axios from "../../configs/axios.config";

export const createStaff = (data) =>
  Axios.post(`/staff`, data).then((response) => response.data.data);
export const updateStaff = (data, id) =>
  Axios.put(`/staff/${id}`, data).then((response) => response.data.data);
export const getStaffList = (data) =>
  Axios.get("/staff", { params: data }).then((response) => response.data.data);
export const getStaffDetail = (id) =>
  Axios.get(`/staff/${id}`).then((response) => response.data.data);
export const deleteStaff = (id) => Axios.delete(`/staff/${id}`);

export const createStaffExperience = (data) =>
  Axios.post(`/experience`, data).then((response) => response.data.data);
export const updateStaffExperience = (data, id) =>
  Axios.post(`/experience/${id}`, data).then((response) => response.data.data);

// staff attendance
export const createStaffAttendance = (data) =>
  Axios.post("/attendance", data);

export const updateStaffAttendance = (id, data) =>
  Axios.put(`/attendance/${id}`, data);

export const getStaffAttendanceById = (id) =>
  Axios.get(`/attendance/${id}`).then((response) => response.data);


export const getStaffAttendance = () =>
  Axios.get(`/daily-attendance`).then((response) => response.data);

export const deleteStaffAttendance = (id) =>
  Axios.delete(`/attendance/${id}`).then((response) => response.data);
export const getStaffAttendanceByDate = (date) =>
  Axios.get(`/attendance/initial-data`)
    .then((response) => response.data)
    .catch((error) => {
      console.warn("Attendance API endpoint not available:", error.message);
      // Return empty data structure to prevent crashes
      return { data: [], total: 0 };
    });
export const getStaffAttendanceByStaff = (data) =>
  Axios.get(`/attendance/attendance-by-staff`, {
    params: { user_id: data },
  }).then((response) => response.data);

export const getStaffAttendanceByGroupDate = (params) => Axios.get(`/staff/attendance/attendance-by-group-date`, { params }).then(response => response.data.data);
export const getClassAttendanceByDate = (params) => Axios.get(`/staff/attendance/attendance-by-class`, { params }).then(response => response.data.data);

export const getAllStaffAttendance = (params) =>
  Axios.get(`/attendance/users-attendance-by-date`, { params }).then(
    (response) => response.data
  );

export const getStaffMedicalRecords = (params) =>
  Axios.get(`/medical-record`, { params }).then((response) => response.data.data);

export const getStaffByDepartmentId = (params) =>
  Axios.get(`/staff/attendance/import-initial-data`, { params }).then(
    (response) => response.data.data
  );

export const importStaffAttendance = (data) =>
  Axios.post(`/staff/attendance/import`, data)
